<style scoped>
.auto-time-checkbox-block {
    padding: 10px 0 0 70px;
}

.timezone p {
    padding: 20px 0 0 60px;
}

.clock-block .clock-data p {
    padding: 20px 0 0 60px;
}
</style>

<template>
<div class="col-12 settings-page">
    <div class="loader loader-in-group-settings" v-if="loader_block">
        <loader-component></loader-component>
    </div>
    <div v-if="!loader_block">
        <div class="offset-md-3 col-md-6">
            <msg-component :type_msg="msg_general.type" :text="msg_general.text"></msg-component>
        </div>
        <div class="col-12 row input-setting-block">
            <div class="offset-1 col-1 elips"></div>
            <div class="col-2 item-name">Имя группы</div>
            <div class="col-7">
                <input v-bind:class="{fail: name_msg}" type="text" v-model="group_name">
        </div>
                <div v-if="name_msg" class="offset-4 col-7 after-input-msg">
                    <p>{{name_msg}}</p>
                </div>
                <div class="offset-4 col-7 text-info-after-input-block">
                    <p>Название группы кранов, будет отображаться в списке групп</p>
                </div>
            </div>
            <div class="col-12 row clock-block input-setting-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">
                Дата и время
                </div>
                <div class="col-7 clock-data">
                <p>{{clock}}</p>
                </div>
            </div>
            <div class="col-12 row input-setting-block">
                <div class="offset-1 col-1 elips"></div>
                <div class="col-2 item-name">Временная зона</div>
                <div class="col-7 aquazor-selector">
                    <v-select :clearable="false" label="name" :options="timezones_list" v-model="select_timezone"></v-select>
                </div>
                <div class="offset-4 col-7 text-info-after-input-block">
                    <p>Наименования зон часовых поясов</p>
                </div>
                <!-- <div class="offset-1 col-1 elips"></div>
        <div class="col-2 item-name">
          Часовой пояс
        </div>
        <div class="col-7 timezone">
          <p>{{select_timezone.name}}</p>
        </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import msg from "./elements/msg.vue";
import axios from "axios";
import config from "@/config.js";
import loader from "./elements/loader.vue";
import timezones from "@/assets/timezones_ru.json";

export default {
    created() {
        GetGroupSettings(this);
        this.clock_interval = setInterval(() => {
            this.date = new Date
        }, 1000)
    },
    mounted() {
        console.log(this.timezones_list);
    },
    components: {
        "v-select": vSelect,
        "loader-component": loader,
        "msg-component": msg
    },
    data() {
        return {
            msg_general: {
                type: "hidden",
                text: ""
            },
            group_name: null,
            loader_block: true,
            save_status: true,
            name_msg: "",
            timezones_list: timezones,
            select_timezone: null,
            timezone: null,
            clock_interval: null,
            date: new Date,
            clock: ''
        };
    },
    methods: {
        
    },
    watch: {
        group_name: function (this_group_name, old_group_name) {
            if (old_group_name != null && this_group_name != old_group_name) {
                setTimeout(() => {
                    if (this_group_name == this.group_name) {
                        saveName(this_group_name, this);
                    }
                }, 1000);
            }
        },
        select_timezone: function (this_timezone, old_timezone) {
            if (old_timezone != null && this_timezone != old_timezone) {
                changeGroupTimezone(this_timezone.tz, this_timezone.number, this);
            }
        },
        date: function (date) {
            if (this.timezone) {
                date.setTime(date.getTime() + (this.timezone.offset * 60 * 60 * 1000))
                this.clock = zero_in_start(date.getUTCDate()) + '-' + zero_in_start(date.getUTCMonth()+1) + '-' + date.getUTCFullYear() + ' ' +
                    date.getUTCHours() + ':' + zero_in_start(date.getUTCMinutes()) + ':' + zero_in_start(date.getUTCSeconds())
            }
        }
    },
    destroyed() {
        this.save_status = false;
        clearInterval(this.clock_interval)
    }
};

function GetGroupSettings(vue_obj) {
    var post_data = new FormData();
    post_data.set("token", localStorage.token);
    post_data.set("id_group", vue_obj.$route.params.id_group);

    axios({
            method: "POST",
            url: config.API_HOST + "/groups/get_group_settings",
            data: post_data
        })
        .then(function (response) {
            console.log(response.data);
            if (!!response.data.name) {
                vue_obj.group_name = response.data.name;
            }

            if (!!response.data.select_timezone && vue_obj.timezones_list) {
                vue_obj.timezones_list.forEach(timezone_data => {
                    if (response.data.select_timezone_number == timezone_data["number"]) {
                        vue_obj.select_timezone = timezone_data;
                    }
                });
            }
            GetGroupTimezone(vue_obj);
            vue_obj.loader_block = false;
        })
        .catch(function (error) {
            console.log(error.response.data);
        });
}

function GetGroupTimezone(vue_obj) {
    const post_data = new URLSearchParams();
    post_data.append("token", localStorage.token);
    post_data.append("id_group", vue_obj.$route.params.id_group);

    axios({
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Accept: "*/*"
            },
            url: config.API_HOST + "/groups/get_timezone",
            data: post_data
        })
        .then(function (response) {
            console.log(response.data);
            if (!!response.data.timezone_data) {
                vue_obj.timezone = response.data.timezone_data;
            }
        })
        .catch(function (error) {
            console.log(error.response.data);
        });
}

function saveName(new_name, vue_obj) {
    vue_obj.msg_general = {
        type: "hidden",
        text: ""
    };
    vue_obj.name_msg = "";
    var post_data = new FormData();
    post_data.set("token", localStorage.token);
    post_data.set("id_group", vue_obj.$route.params.id_group);
    post_data.set("name", vue_obj.group_name);

    axios({
            method: "POST",
            url: config.API_HOST + "/groups/change_group_name",
            data: post_data
        })
        .then(function (request) {
            console.log(request);
            vue_obj.$eventHub.$emit("LayoutGroupNameEvent", new_name);
        })
        .catch(function (error) {
            if (!!error.response.data.exceptions) {
                vue_obj.msg_general = {
                    type: "alert",
                    text: error.response.data.exceptions
                };
            }

            if (!!error.response.data.fields_exceptions) {
                error.response.data.fields_exceptions.forEach(field_exception => {
                    if (field_exception["name"] == "name") {
                        vue_obj.name_msg = field_exception["exception"];
                    }
                });
            }
        });
}

function changeGroupTimezone(this_timezone, timezone_number, vue_obj) {
    var post_data = new FormData();
    post_data.set("token", localStorage.token);
    post_data.set("id_group", vue_obj.$route.params.id_group);
    post_data.set("timezone_city_name", this_timezone);
    post_data.set("timezone_number", timezone_number);

    axios({
            method: "POST",
            url: config.API_HOST + "/groups/change_group_timezone",
            data: post_data
        })
        .then(function (request) {
            console.log(request);
            GetGroupTimezone(vue_obj);
        })
        .catch(function (error) {
            // TODO сделать реакцию на ошибку
            console.log(error);
        });
}

function zero_in_start(number) {
  if (number >= 0 && number <= 9) {
    return '0' + number
  } else {
    return number
  }
}
</script>



// WEBPACK FOOTER //
// src/components/group-settings.vue